import React, { useState } from 'react';
import { IoMdCloseCircle } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
interface TextAreaPopUpProps {
    show: boolean;
    message: string;
    onConfirm: (reason: string) => void; // Pass reason to onConfirm
    onCancel: () => void;
}

const TextAreaPopUp: React.FC<TextAreaPopUpProps> = ({
    show,
    message,
    onConfirm,
    onCancel,
}) => {
    const [reason, setReason] = useState('');
    const [error, setError] = useState<string | null>(null);
    const { t } = useTranslation();

    if (!show) {
        return null;
    }

    const handleSubmit = () => {
        if (reason.trim() === '') {
            setError('Please enter a reason');
            return;
        }

        onConfirm(reason.trim());
        setReason('');
        setError(null);
    };

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setReason(e.target.value);
        if (error && e.target.value.trim() !== '') {
            setError(null);
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg relative w-80">
                <button
                    className="absolute top-0 right-0 mt-2 mr-2 text-black"
                    onClick={onCancel}
                    aria-label="close"
                >
                    <IoMdCloseCircle className="text-lg" />
                </button>
                <div className="my-4">
                    <p className="mb-3 text-light_grey font-bold text-sm">
                        {message}
                    </p>
                    {/* <textarea
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        className="w-full h-24 border border-gray-300 placeholder-gains_boro rounded px-3 py-2"
                        placeholder="Type your reason"
                    ></textarea> */}
                    <textarea
                        value={reason}
                        onChange={handleChange}
                        className={`w-full h-24 border ${error ? 'border-red-500' : 'border-gray-300'} placeholder-gains_boro rounded px-3 py-2`}
                        placeholder="Type your reason"
                    ></textarea>
                    {error && (
                        <p className="text-red-500 text-sm mt-1">{error}</p>
                    )}
                    <div className="flex justify-center mt-4">
                        <button
                            onClick={handleSubmit}
                            className="!bg-primary text-white font-bold text-sm py-1 px-4 mr-5 w-24 rounded"
                        >
                            {t('submit')}
                        </button>
                        <button
                            onClick={onCancel}
                            className="border !border-primary !text-primary font-bold text-sm py-1 px-4 w-24 rounded"
                        >
                            {t('cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TextAreaPopUp;
